import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon, LockIcon } from 'lucide-react';
interface SensitiveFieldProps {
  label: string;
  masked: string;
  revealed: string;
  maskedDetail?: string;
  revealedDetail?: string;
}
export function SensitiveField({
  label,
  masked,
  revealed,
  maskedDetail,
  revealedDetail
}: SensitiveFieldProps) {
  const [visible, setVisible] = useState(false);
  const detail = visible ? revealedDetail : maskedDetail;
  return <div data-id="element-443" data-mp="2s9ev1wxnogls">
      <dt className="text-[11px] font-medium uppercase tracking-wider text-muted" data-id="element-444" data-mp="2s95fz4e5ftuv">{label}</dt>
      <dd className="mt-1 flex items-center gap-2" data-id="element-445" data-mp="2naakb1v32atc">
        <span className={`text-sm tabular-nums ${visible ? 'text-slate-800' : 'tracking-wider text-slate-600'}`} data-id="element-446" data-mp="3191xmm24fsgf">{visible ? revealed : masked}</span>
        <button type="button" onClick={() => setVisible(v => !v)} aria-label={visible ? `Hide ${label}` : `Reveal ${label}`} aria-pressed={visible} className="rounded-md p-1 text-mutedlight transition hover:bg-azure/10 hover:text-azure" data-id="element-447" data-mp="2wb8uk1w47ekd">
          {visible ? <EyeOffIcon className="h-4 w-4" data-id="element-448" data-mp="scb6almk5eoz" /> : <EyeIcon className="h-4 w-4" data-id="element-449" data-mp="sb9vmi9geu7s" />}
        </button>
      </dd>
      {detail && <p className={`text-xs ${visible ? 'text-slate-600' : 'italic text-mutedlight'}`} data-id="element-450" data-mp="xaw9mtx3wehn">{detail}</p>}
      <p className="mt-0.5 inline-flex items-center gap-1 text-[10px] font-medium text-mutedlight" data-id="element-451" data-mp="12b0s2phkrjai">
        <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-452" data-mp="4n8rrmn801yp" /> Admin only
      </p>
    </div>;
}